var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC2CToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C12.6185 0 15.0039 1.00778 16.7858 2.65471L15.357 4.20076C13.9487 2.89915 12.0682 2.10526 10 2.10526C5.63986 2.10526 2.10526 5.63986 2.10526 10C2.10526 14.3601 5.63986 17.8947 10 17.8947C12.0682 17.8947 13.9487 17.1009 15.357 15.7992L16.7858 17.3453C15.0039 18.9922 12.6184 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8534 9.99998C13.8534 7.80499 12.1153 6.06238 10.0163 6.06238C8.93417 6.06241 7.95415 6.52124 7.25234 7.26895L5.71759 5.828C6.79582 4.67932 8.322 3.95715 10.0163 3.95712C13.3182 3.95712 15.9586 6.68291 15.9586 9.99998C15.9586 13.3171 13.3182 16.0428 10.0163 16.0428C8.32199 16.0428 6.79582 15.3207 5.71759 14.172L7.25234 12.7313C7.95415 13.479 8.93417 13.9376 10.0163 13.9376C12.1153 13.9376 13.8534 12.195 13.8534 9.99998Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5866 10.0001C11.5866 11.0174 10.7618 11.8422 9.74445 11.8422C8.72708 11.8422 7.90234 11.0174 7.90234 10.0001C7.90234 8.9827 8.72708 8.15796 9.74445 8.15796C10.7618 8.15796 11.5866 8.9827 11.5866 10.0001Z",
    fill: "#47B022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2CToken);
export default __webpack_public_path__ + "static/media/c2c-token.fbbec83ca3f45dde26d8ad3a6830ccce.svg";
export { ForwardRef as ReactComponent };